export default __webpack_public_path__ + "static/media/rug8-min.2fcdfc4c.jpg";